export default {"src":"/_next/static/media/newLoader.59055daf.gif","height":1296,"width":1296};